import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 100%;
    padding: 8px 8px 8px 12px;
    color: ${colors.prussian};
  `,
  buttonCancelSpacing: css`
    padding-left: 16px;
  `,
  link: css`
    font-size: 13px;
    color: ${colors.jungle};
    text-decoration: underline;
  `,
  sectionSpacing: css`
    padding: 24px 8px 0px 16px;
  `,
  searchItem: css`
    display: flex;
    /* font-family: 'Montserrat Medium'; */
    font-size: 16px;
    line-height: 1.5;
    letter-spacing: -0.5px;
    color: ${colors.prussian};
    padding-bottom: 12px;
    gap: 9.7px;
    cursor: pointer;
  `,
  iconStone: css`
    color: ${colors.stone};
  `,
  highlightText: css`
    & > span {
      text-transform: capitalize;
      font-family: 'Montserrat Regular';
      font-weight: normal;
    }
    font-family: 'Montserrat Bold';
    font-weight: bold;
    font-size: 16px;
  `,
  textBold: css`
    font-weight: bold;
  `,
  results: css`
    display: flex;
    flex-direction: column;
  `,
  resultsContainer: css`
    padding: 16px 8px 0px 16px;
  `,
  savedSearches: css`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  `,
  separator: css`
    padding-top: 8px;
    padding-bottom: 20px;
  `,
  suggestedCategoriesResults: css`
    padding-top: 16px;
  `,
};

export default styles;
